module.exports = __webpack_public_path__ + "static/img/img1.8149820.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img1.png
// module id = ZeQB
// module chunks = 1